if (!customElements.get('product-flavours')) {
  class ProductFlavours extends HTMLElement {
    constructor() {
      super();

      this.list = this.querySelector('.product-flavours__list');
      this.prevBtn = this.querySelector('[data-flavours-prev]');
      this.nextBtn = this.querySelector('[data-flavours-next]');

      this.addEventListener('click', this.handleClick.bind(this));
    }

    /**
     * Handles 'click' events on flavour items and nav arrows.
     * @param {object} evt - Event object.
     */
    handleClick(evt) {
      const prev = evt.target.closest('[data-flavours-prev]');
      const next = evt.target.closest('[data-flavours-next]');
      if (prev || next) {
        evt.preventDefault();
        this.scrollList(prev ? -1 : 1);
        return;
      }

      const item = evt.target.closest('.product-flavours__item');
      if (!item) return;

      evt.preventDefault();
      this.swapProduct(item);
    }

    /**
     * Scrolls the flavour list left or right.
     * @param {number} direction - -1 for previous, 1 for next.
     */
    scrollList(direction) {
      if (!this.list) return;
      const amount = this.list.clientWidth * 0.8 * direction;
      this.list.scrollBy({ left: amount, behavior: 'smooth' });
    }

    /**
     * Fetches the flavour's product page via the Section Rendering API and
     * swaps the current main product section in place, without a page refresh.
     * @param {HTMLElement} item - The clicked flavour link.
     */
    async swapProduct(item) {
      if (this.classList.contains('is-loading') || item.classList.contains('is-active')) return;

      const url = item.getAttribute('href');
      const section = this.closest('.shopify-section');
      if (!url || !section) {
        window.location.href = url;
        return;
      }

      const sectionId = section.id.replace('shopify-section-', '');
      const scrollY = window.scrollY;
      this.classList.add('is-loading');
      this.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch(`${url}?section_id=${sectionId}&view=melting-waffels`);
        if (!response.ok) throw new Error(response.status);

        const tmpl = document.createElement('template');
        tmpl.innerHTML = await response.text();

        const newSection = tmpl.content.querySelector(`#shopify-section-${sectionId}`);
        if (!newSection) throw new Error('Section not found in response');

        ProductFlavours.reviveScripts(newSection);
ProductFlavours.reviveLazyImages(newSection);
section.replaceWith(newSection);





        // Re-initializing the section (sticky/lazy-load components, images
        // reflowing, etc.) can briefly change the document height, which
        // makes the browser auto-clamp scroll position. Force it back.
        window.scrollTo(0, scrollY);
        requestAnimationFrame(() => window.scrollTo(0, scrollY));
        setTimeout(() => window.scrollTo(0, scrollY), 150);

        // window.history.pushState({}, '', url);
        document.dispatchEvent(new CustomEvent('on:flavour:change', { detail: { url } }));
      } catch (error) {
        window.location.href = url;
      }
    }






 




    /**
     * Replaces every <script> in the fetched section with an equivalent,
     * freshly created node so the browser actually executes it (scripts
     * inserted via innerHTML/template parsing never run on their own).
     * @param {HTMLElement} root - Root element to scan for scripts.
     */
    static reviveScripts(root) {
      root.querySelectorAll('script').forEach((oldScript) => {
        const newScript = document.createElement('script');
        Array.from(oldScript.attributes).forEach((attr) => {
          newScript.setAttribute(attr.name, attr.value);
        });
        newScript.textContent = oldScript.textContent;
        oldScript.replaceWith(newScript);
      });
    }


static reviveLazyImages(root) {
  root.querySelectorAll('img[data-src]').forEach((img) => {
    if (img.dataset.srcset) img.srcset = img.dataset.srcset;
    if (img.dataset.src) img.src = img.dataset.src;
    img.classList.remove('no-js-hidden'); // if your CSS hides until this class is removed
  });
}
  }

  customElements.define('product-flavours', ProductFlavours);
}
